<template>
    <div id="wrapper">
      <Sidebar></Sidebar>
      <!-- Content Wrapper -->
      <div id="content-wrapper" class="d-flex flex-column">

        <!-- Main Content -->
        <div id="content">

          <Topbar></Topbar>

          <!-- Begin Page Content -->
          <div class="container-fluid">

            <!-- Page Heading -->
            <h1 class="h3 mb-2 text-gray-800">英文版聯絡表單{{mode}}</h1>

            <!-- DataTales Example -->
            <div class="card shadow mb-4">
                <div class="card-header py-3">
                    <button type="button" class="btn btn-primary" v-on:click="Post" v-if="!is_edit ">新增</button>
                    <button type="button" class="btn btn-danger" v-on:click="Delete" data-bs-toggle="tooltip" data-bs-placement="top" v-if="is_edit">刪除</button>
                </div>
                <div class="card-body">
                    <form>
                        <div class="form-group">
                            <label for="name">姓名*</label>
                            <input type="text" class="form-control form-control-user" id="name"  v-model="item.name" autocomplete="username" :disabled="is_edit">
                        </div>
                        <div class="form-group">
                            <label for="company">公司名稱</label>
                            <input type="text" class="form-control form-control-user" id="company"  v-model="item.company" :disabled="is_edit">
                        </div>
                        <div class="form-group">
                            <label for="phone">電話*</label>
                            <input type="text" class="form-control form-control-user" id="phone"  v-model="item.phone" :disabled="is_edit">
                        </div>
                        <div class="form-group">
                            <label for="email">E-mail*</label>
                            <input type="email" class="form-control form-control-user" id="email"  v-model="item.email" :disabled="is_edit">
                        </div>
                        <div class="form-group">
                            <label for="title">主旨*</label>
                            <input type="text" class="form-control form-control-user" id="title"  v-model="item.title" :disabled="is_edit" >
                        </div>
                        <div class="form-group">
                            <label for="desc">內容</label>
                            <textarea class="form-control" id="desc" rows="3" v-model="item.desc" placeholder="請簡述您想詢問的問題" :disabled="is_edit"></textarea>
                        </div>
                    
                    </form>
                </div>
            </div>

          </div>
          <!-- /.container-fluid -->

        </div>
        <!-- End of Main Content -->

        <Footer></Footer>

      </div>
      <!-- End of Content Wrapper -->
    </div>
</template>

<script>
import moment from 'moment'
import {fb, db } from '../firebase'
export default {
  name: 'ContactInfo',
  data () {
    return {
      id:this.$route.params.id,
      mode:'',
      is_edit:false,
      item:{
          name:'',
          company:'',
          phone:'',
          email:'',
          title:'',
          desc:'',
          date:moment().format("YYYY-MM-DD HH:mm:ss"),

      }
    }
  },
  mounted () {
    this.Switch();
    this.Get();
  },
  methods: {
    Switch() {
      if ( this.$route.name == 'Contact_enAdd'  ) {
          this.mode = '新增';
      } else {
          this.mode = '編輯';
          this.is_edit = true;
      }
    },
    Get(){
      if ( this.$route.name != 'Contact_enAdd'  ) {
        db.collection("contact_en").doc(this.id).get().then((doc) => {
            if (doc.exists) {
              this.item = doc.data();
            } else {
              this.$router.push({name: 'Contact_en'}); 
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    },
    Post() {
      if ( this.item.name == '' ) {
        alert('姓名不可為空!');
      } else if ( this.item.phone == '' ) {
        alert('電話不可為空!')
      } else if ( this.item.email == '' ) {
        alert('E-mail不可為空!')
      } else if ( this.title == '' ) {
        alert('主旨不可為空!') 
      } else if ( this.Dㄏ == '' ) {
        alert('內容不可為空!') 
      }else {
        
        db.collection("contact_en").doc(this.id).set(this.item)
        .then((doc) => {
            alert("成功!");
            this.$router.push({name: 'Contact_en'}); 
        }).catch((error) => {
            console.log("Error getting document:", error);
        });

      }   
    },
    Update() {
        db.collection("contact_en").doc(this.id).update(this.item)
          .then(() => {
              alert("成功!");
              this.$router.push({name: 'Contact_en'}); 
          }).catch((error) => {
              console.log("Error getting document:", error);
          });

    },
    Delete() {
      if ( confirm("確定要刪除?") ) {
        db.collection("contact_en").doc(this.id).delete()
        .then(() => {
            alert("刪除成功!");
            this.$router.push({name: 'Contact_en'}); 
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
      }
    }
  }
}
</script>

<style scoped>
label{
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/ContactInfoEN.vue